import * as React from "react";
import { createPortal } from "react-dom";
const Portal = ({ children, container = document.body }) => /* @__PURE__ */ React.createElement(React.Fragment, null, createPortal(children, container));
export default Portal;
